import { render } from "./PropertyAdditionals.vue?vue&type=template&id=5947789d"
import script from "./PropertyAdditionals.vue?vue&type=script&lang=js"
export * from "./PropertyAdditionals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__